import { Divider, Flex, IconButton, Spacer } from '@chakra-ui/react'
import { faMinus } from '@fortawesome/pro-regular-svg-icons'

import DatePicker from 'src/components/widgets/DatePicker/DatePicker'
import Icon from 'src/components/widgets/Icon/Icon'
import Input from 'src/components/widgets/Input/Input'

import usePromoCodeEditor from './usePromoCodeEditor'

export const PromoCodeEditor = ({
  close,
  name,
}: {
  close: () => void
  name: string
}) => {
  const { clearPromoCode } = usePromoCodeEditor(close, name)

  return (
    <>
      <Divider color="sandstone" my={6} />
      <Flex mb={6} alignItems="center">
        <h5 className="thick" data-testid="promoCodeEditor-promoCodeTitle">
          Promo Code
        </h5>
        <Spacer />
        <IconButton
          variant="function"
          borderRadius="full"
          aria-label="Remove Promo Code"
          h="28px"
          w="28px"
          onClick={clearPromoCode}
          icon={<Icon icon={faMinus} />}
          data-testid="promoCodeEditor-remove"
        ></IconButton>
      </Flex>
      <Input
        mb={4}
        w="100%"
        name={`${name}.promoCodeCode`}
        placeholder="Code"
        data-testid="promoCodeEditor-promoCodeField"
      />
      <Input
        mb={4}
        w="100%"
        name={`${name}.promoCodeDiscount`}
        placeholder="Discount: ie. 15% off..."
        data-testid="promoCodeEditor-promoDiscount"
      />
      <Flex w="100%" gap={4}>
        <Flex w="100%" data-testid="promoCodeEditor-datePickerFrom">
          <DatePicker
            name={`${name}.promoCodeValidFrom`}
            placeholder="Valid From"
            flex={1}
          />
        </Flex>
        <Flex w="100%" data-testid="promoCodeEditor-datePickerTo">
          <DatePicker
            name={`${name}.promoCodeValidTo`}
            placeholder="Valid To"
            endOfDay={true}
            flex={1}
          />
        </Flex>
      </Flex>
    </>
  )
}
